import "../components/store/store.scss";
import React from "react";
import { Row, Col, Card, CardHeader, CardTitle, CardBody, CardFooter, Button } from "reactstrap";
import { LinkButton } from "../components/common/buttons";

import CameraModelScreenshots from "../components/cameraModel/CameraModelScreenshots";
import { getStoreByLocation } from "../services/storeService";

class StoreScreenshotToolsView extends React.Component {
  state = {
    storeLocation: null,
    storeId: null,
  };

  async componentDidMount() {
    const { match } = this.props;
    const storeLocation = match.params.location;
    await getStoreByLocation(storeLocation).then((response) => this.setState({ storeId: response.data.id }));
    this.setState({ storeLocation });
  }

  render() {
    const { storeLocation, storeId } = this.state;
    return (
      <div className="content">
        <Row>
          <Col md="12">
            {storeLocation && (
              <Card className="store-config">
                <CardHeader className="mb-2">
                  <h5 className="card-category">Store Screenshot tools</h5>
                  <CardTitle tag="h2">
                    {storeLocation}
                    <a className="ml-3" href={`/stores/${storeId}`}>
                      <Button>Store config</Button>
                    </a>
                    <span className="ml-2">
                      <LinkButton href={`/capabilities/${storeLocation}`} label="Dashcam" />
                    </span>
                  </CardTitle>
                </CardHeader>
                <CardBody>
                  <CameraModelScreenshots storeId={storeId} storeLocation={storeLocation} />
                </CardBody>
                <CardFooter />
              </Card>
            )}
          </Col>
        </Row>
      </div>
    );
  }
}

export default StoreScreenshotToolsView;
